/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Elevenlabs_Connect_ButtonInputs */



/**
* | output |
* | --- |
* | "Connect ElevenLabs" |
*
* @param {Voice_Manager_Elevenlabs_Connect_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_connect_button = /** @type {((inputs?: Voice_Manager_Elevenlabs_Connect_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_Connect_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connecter ElevenLabs")
	if (locale === "de") return /** @type {LocalizedString} */ ("ElevenLabs verbinden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Connetti ElevenLabs")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подключить ElevenLabs")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conectar ElevenLabs")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("连接 ElevenLabs")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ElevenLabs を接続")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ElevenLabs कनेक्ट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ligar a ElevenLabs")
	return /** @type {LocalizedString} */ ("Connect ElevenLabs")
});